import { render, staticRenderFns } from "./CardLectura.vue?vue&type=template&id=b123ca4e&"
import script from "./CardLectura.vue?vue&type=script&lang=js&"
export * from "./CardLectura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports